export const texts = {
  copyright: `Działanie współfinansowane ze środków Unii Europejskiej, w ramach
        Europejskiego Funduszu Rozwoju Regionalnego, Program Operacyjny Polska
        Wschodnia, oś priorytetowa I: Przedsiębiorcza Polska Wschodnia,
        działanie 1.1 Platformy Startowe dla nowych pomysłów; poddziałanie
        1.1.1 Platformy startowe dla nowych pomysłów.`,
  registeredSuccessfully: `Gratulacje, rejestracja powiodła się! Na podany adres mailowy
        wysłaliśmy wiadomość z linkiem aktywacyjnym. Aby aktywować konto
        kliknij w link w wiadomości.`,

  accountAcitivationLinkSent: `Na adres mailowy podany podczas rejestracji wysłaliśmy linkaktywacyjny`,
  accountActivationLinkSentInfo: `Sprawdź skrzynkę mailową (wiadomość mogła trafić do folderu SPAM)`,
  passwordResetLinkSent: `Jeżeli podałeś poprawny adres mailowy to na Twoją skrzynkę pocztową
        została wysłana wiadomość z linkiem do zrestartowania hasła.`,
  passwordChanged: `Twoje hasło zostało pomyślnie zmienione. Możesz się teraz zalogować korzystając 
        z nowego hasła.`,

  accordionFormSubmitUnableToCheck: `Niestety nie udało nam się sprawdzić Twojej współpracy 
  z sektorem finansowym, sprawdź ponownie swoje dane'`,
  accordionFormSubmitLoanTooHigh: `Niestety Twoje zyski są zbyt małe na tą wysokość kredytu
   – proponujemy spróbować z niższą kwotą!`,
  accordionFormSubmitNoBIGAccess: `Niestety nie możemy sprawdzić Twojej wypłacalności bez 
  Twojej zgody! Proszę potwierdzić swoją zgodę na przetwarzanie danych.`,
  accordionFormSubmitCustomerNotSolvent: `Niestety, Twoja dotychczasowa współpraca 
  z sektorem finansowym nie pozwala na udzielnie Ci kredytu.`,
  accordionFormSubmitError: `W trakcie procesu weryfikacji wystąpił błąd, spróbuj ponownie 
  później!`,
  accordionFormSubmitSuccess: `Gratulujemy, możesz otrzymać wybrany kredyt! Kliknij poniżej 
  aby, przejść do podpisywania umowy!`,
  accordionFormSubmitUserNoPermissions: `Brak uprawnień: Ze względu na ochronę Twojej prywatności 
  w wersji demonstracyjnej tylko określone osoby mają możliwość pobrania informacji o Twoim wniosku.`,

  accordionFormAdditionalPermissions: `Aby obliczyć Twoją zdolność kredytową potrzebujemy jeszcze zgody na przetwarzanie 
        Twoich danych. Dane kontaktowe będą pomocne w razie pytań.`,
  accordionFormAdditionalPermissionsCheckbox1: `Wyrażam zgodę, zgodnie z ustawą z dnia 18 lipca 2002 r. o świadczeniu usług drogą
        elektroniczną na otrzymywanie od Agrowe App Sp. z o. o. drogą elektroniczną informacji
        stanowiących informacje handlowe w rozumieniu ww. ustawy, w tym wiadomości email.`,
  accordionFormAdditionalPermissionsCheckbox2: `Wyrażam zgodę na przetwarzanie przez Agrowe App. Sp. z o. o., Królewski Dwór 4, 21-200
        Parczew, zarejestrowaną w rejestrze przedsiębiorców Krajowego Rejestru Sądowego przez
        Sąd Rejonowy dla regionu Lublin Wschód, XII Wydział Gospodarczy Krajowego Rejestru
        Sądowego pod nr KRS 0000856321, posiadający NIP 5391515336 oraz kapitał zakładowy w
        wysokości 5000 zł w całości wpłacony, moich danych osobowych wskazanych w Formularzu
        rejestracyjnym, w celu marketingu produktów i usług własnych`,
  accordionFormAdditionalPermissionsCheckbox3: `Wyrażam zgodę na przetwarzanie przez bank XXXX z siedzibą w XXXXXX, ul. XXXX
        XX/XX, kod pocztowy: XX-XXX XXXXXX, zarejestrowaną w rejestrze przedsiębiorców
        Krajowego Rejestru Sądowego przez Sąd Rejonowy dla XXXXXX, XII Wydział
        Gospodarczy Krajowego Rejestru Sądowego pod nr KRS XXXXXXX, posiadający NIP
        XXXXX oraz kapitał zakładowy w wysokości XXXXXXXXX zł w całości wpłacony
        („Bank”), moich danych osobowych wskazanych w Formularzu rejestracyjnym, w celu
        marketingu produktów i usług własnych Banku.`,
  accordionFormAdditionalPermissionsUserDataInfo: `Administratorem danych osobowych jest Agrowe App Sp. z o.
        o., a podmiotem przetwarzającym dane osobowe jest XXXXX,
        zarejestrowany w rejestrze przedsiębiorców Krajowego
        Rejestru Sądowego przez Sąd Rejonowy dla m. st. Warszawy,
        XII Wydział Gospodarczy Krajowego Rejestru Sądowego pod nr
        KRS XXXXXX. Dane są przetwarzane w celu marketingu i
        promocji produktów i usług oferowanych przez Bank (art. 6
        ust. 1 lit. f RODO). Właściciel danych osobowych ma prawo
        dostępu do danych, żądania ich sprostowania, żądania
        usunięcia, żądania ograniczenia przetwarzania lub prawo
        przenoszenia danych prawo sprzeciwu, prawo wniesienia
        skargi do organu nadzorczego. Każdy właściciel danych
        osobowych ma prawo także do cofnięcia zgody na
        przetwarzanie danych. Cofnięcie zgody nie ma wpływu na
        zgodność z prawem przetwarzania, którego dokonano na
        podstawie zgody przed jej cofnięciem. Szczegółowe zasady
        przetwarzania danych osobowych zawarte są na stronie:
        XXXXXXX`,

  accordionFormFinancialSectorCooperationInfo1: `Na podstawie art. 105 ust. 4a i 4a1 ustawy z dnia 29 sierpnia 1997 roku - Prawo bankowe
        (tekst jednolity Dz.U.2019 poz. 2357 ze zm.) w związku z art. 13 ustawy z dnia 9 kwietnia
        2010 roku o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych
        (tj. Dz.U.2020 poz. 389 ze zm.) niniejszym upoważniam Agrowe App, Sp. z o. o.,
        Królewski Dwór 4, 21-200 Parczew do pozyskania za pośrednictwem Biura Informacji
        Gospodarczej InfoMonitor S.A. z siedzibą w Warszawie przy ul. Zygmunta
        Modzelewskiego 77 (BIG InfoMonitor) danych gospodarczych z Biura Informacji
        Kredytowej S.A.(BIK) i Związku Banków Polskich (ZBP) w zakresie niezbędnym do
        dokonania oceny wiarygodności płatniczej i oceny ryzyka kredytowego. Jednocześnie
        upoważniam ww. przedsiębiorcę do pozyskania z BIG InfoMonitor informacji
        dotyczących składanych zapytań na mój temat do Rejestru BIG InfoMonitor w ciągu
        ostatnich 12 miesięcy`,
  accordionFormFinancialSectorCooperationInfo2: `Na podstawie art. 24 ust.1 ustawy z dnia 9 kwietnia 2010 roku o udostępnianiu informacji
        gospodarczych i wymianie danych gospodarczych (tj. Dz.U.2020 poz. 389 ze. zm.) oraz
        na podstawie art. 105 ust. 4ai 4a1 ustawy z dnia 29 sierpnia 1997 roku - Prawo bankowe
        (tj.Dz.U.2019 poz. 2357 ze zm.) w związku z art. 13 ustawy o udostępnianiu informacji
        gospodarczych i wymianie danych gospodarczych niniejszym upoważniam Agrowe App,
        Sp. z o. o., Królewski Dwór 4, 21-200 Parczew, do pozyskania z Biura Informacji
        Gospodarczej InfoMonitor S.A. z siedzibą w Warszawie przy ul. Zygmunta
        Modzelewskiego 77 (BIG InfoMonitor) dotyczących mnie informacji gospodarczych oraz
        do pozyskania za pośrednictwem BIG InfoMonitor danych gospodarczych z Biura
        Informacji Kredytowej S.A.(BIK) i Związku Banków Polskich (ZBP), w tym między innymi
        oceny punktowej (scoring), w zakresie niezbędnym do dokonania oceny wiarygodności
        płatniczej i oceny ryzyka kredytowego. Jednocześnie upoważniam ww. przedsiębiorcę
        do pozyskania z BIG InfoMonitor informacji dotyczących składanych zapytań na mój
        temat do Rejestru BIG InfoMonitor wciągu ostatnich 12 miesięcy.`,
};

export default texts;
